// extracted by mini-css-extract-plugin
export var container = "zgvANpDK";
export var label = "_7oxMrHa1";
export var subfieldsContainer = "_0K6G-EkW";
export var gridCols6 = "_94cLpDD2";
export var header = "vNyEIaDD";
export var errorTooltip = "JYLFUDny";
export var active = "j9eOfvU+";